module.exports = __webpack_public_path__ + "static/img/software32.e0f19f01.png";